


































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GET_DEPARTMENT } from './getDepartment';

@Component
export default class DepartmentShow extends Vue {
  public GET_DEPARTMENT = GET_DEPARTMENT;
  @Prop(String) public id!: string;
}
